export default {
    COMPETENCES: 'competences',
    IMAGE_IMPORT: 'image_import',
    MEDIA_CAPTION_UPDATE: 'media_caption_update',
    MEDIA_SHOW: 'media_show',
    ORGANIZATION_SEARCH_FEEDBACK_MODAL: 'organization_search_feedback_modal',
    YOUTUBE_VIDEO_IMPORT: 'youtube_video_import'
}